/**
 * Mock carrier data, mimicking the `carrierData` object the real backend embeds on each
 * shipment solution. Since the frontend carrier integration was removed (carrier icons/names
 * no longer live in the code), the mocked environments need to provide this enrichment
 * themselves so shipment option logos render in demo/mocked mode.
 *
 * Keyed by the carrier id used in the mock product bundles. Shape matches what `CarrierIcon`
 * and `shipment.core.js` read: `displayName`, `iconUrl`, and optional `color`.
 */
export const MOCK_CARRIERS_DATA = {
    AHLENS_STORE: { id: "AHLENS_STORE", displayName: "Return in Åhléns Store", iconUrl: "/icons/delivery/ovals/M-Ahlens.svg" },
    BUDBEE: { id: "BUDBEE", displayName: "Budbee", iconUrl: "/icons/delivery/ovals/C-Budbee.svg" },
    COS_STORE: { id: "COS_STORE", displayName: "Return in COS Store", iconUrl: "/icons/delivery/ovals/M-COS Stores.svg" },
    DHL_EXPRESS: { id: "DHL_EXPRESS", displayName: "DHL Express", iconUrl: "/icons/delivery/ovals/C-DHL Express.svg" },
    DHL_FREIGHT: { id: "DHL_FREIGHT", displayName: "DHL Freight", iconUrl: "/icons/delivery/ovals/C-DHL.svg" },
    DOORIS: { id: "DOORIS", displayName: "Dooris", iconUrl: "/icons/delivery/ovals/C-Dooris.svg" },
    EVRI: { id: "EVRI", displayName: "Evri", iconUrl: "/icons/delivery/ovals/C-Evri.svg" },
    FED_EX: { id: "FED_EX", displayName: "FedEx", iconUrl: "/icons/delivery/ovals/C-FedEx.svg" },
    HM_STORE: { id: "HM_STORE", displayName: "Return in H&M Store", iconUrl: "/icons/delivery/ovals/M-HM.svg" },
    IN_STORE: { id: "IN_STORE", displayName: "Return in store", iconUrl: "/icons/delivery/in_store_logo.svg" },
    INPOST: { id: "INPOST", displayName: "InPost", iconUrl: "/icons/delivery/ovals/C-Inpost.svg" },
    POST_NL: { id: "POST_NL", displayName: "PostNL", iconUrl: "/icons/delivery/ovals/C-Postnl.svg" },
    POSTNORD: { id: "POSTNORD", displayName: "PostNord", iconUrl: "/icons/delivery/ovals/C-Postnord.svg", color: "#01b3f0" },
    RITUALS_STORE: { id: "RITUALS_STORE", displayName: "Return in Rituals Store", iconUrl: "/icons/delivery/ovals/M-Rituals.svg" },
    ROYAL_MAIL: { id: "ROYAL_MAIL", displayName: "Royal Mail", iconUrl: "/icons/delivery/ovals/C-Royal Mail.svg" },
    UPS: { id: "UPS", displayName: "United Parcel Service", iconUrl: "/icons/delivery/ovals/C-UPS.svg" },
    USPS: { id: "USPS", displayName: "United States Postal Service", iconUrl: "/icons/delivery/ovals/C-USPS.svg" },
};

/**
 * Attaches mock `carrierData` to each shipment solution that has a `carrier` but no
 * `carrierData` yet - the same enrichment the real backend performs. Mutates and returns
 * the passed array so it can be applied to the mocked login response in place.
 */
export function enrichShipmentSolutionsWithCarrierData(shipmentSolutions) {
    shipmentSolutions?.forEach((solution) => {
        if (solution?.carrier && !solution.carrierData && MOCK_CARRIERS_DATA[solution.carrier]) {
            solution.carrierData = MOCK_CARRIERS_DATA[solution.carrier];
        }
    });
    return shipmentSolutions;
}
